module.exports = __webpack_public_path__ + "img/view-circle.a6024a76.svg";